export default __webpack_public_path__ + "assets/248cd231355ea87264fb0a37762c5ea0.gif";